import React from 'react';
import Select from '../../Basic/Select';

const DashboardSelect = p =>
    <div className="row">
      <div className="col-md-6">
      <div className="form-group text-right" style={{ marginBottom: "0px"}}>
        <h5 className="text-primary" style={{ marginTop: "10px"}}>{p.label}:</h5>
          </div>
      </div>
      <div className="col-md-6">
          <div className="form-group">
          <Select name={p.name} className="form-control" items={p.items}/>
          </div>
      </div>     
    </div>

export default DashboardSelect;


